/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueImportResponse = {
    type: 'array',
    contains: {
        type: 'any-of',
        contains: [{
            type: 'LeagueImport_Output',
        }, {
            type: 'string',
        }],
    },
} as const;
